@if (errorConfig) {
    @switch (errorConfig.error?.error_code?.toString()) {
        @case (ERROR_CODE.SYSTEM_UNAVAILABLE) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.SYSTEM_UNAVAILABLE_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.SYSTEM_UNAVAILABLE_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.MEDIA_SERVER_ERROR) {
            @if (errorConfig.waiting) {
                <tec-tile
                    type="loading"
                    [title]="'GENERAL.ERROR.MEDIA_SERVER_RESTARTING_TITLE' | translate"
                    [subtitle]="'GENERAL.ERROR.MEDIA_SERVER_RESTARTING_DESCRIPTION' | translate"
                />
            } @else {
                <tec-tile
                    type="status"
                    tagIconStatus="error"
                    [title]="'GENERAL.ERROR.MEDIA_SERVER_ERROR_TITLE' | translate"
                    [subtitle]="'GENERAL.ERROR.MEDIA_SERVER_ERROR_DESCRIPTION' | translate"
                    icon="icon-alert"
                >
                    @if (errorConfig.action) {
                        <tec-button
                            size="lg"
                            [label]="'GENERAL.BUTTON.RETRY' | translate"
                            (clickEvent)="errorConfig.action()"
                        />
                    }
                </tec-tile>
            }
        }
        @case (ERROR_CODE.DEVTOOLS_BLOCKED) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.DEVTOOLS_BLOCKED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.DEVTOOLS_BLOCKED_DESCRIPTION' | translate"
                icon="icon-alert"
            >
                @if (errorConfig.action) {
                    <tec-button
                        size="lg"
                        [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                        (clickEvent)="errorConfig.action()"
                    />
                }
            </tec-tile>
        }
        @case (ERROR_CODE.UNAUTHORIZED) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.UNAUTHORIZED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.UNAUTHORIZED_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.INVALID_TOKEN) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.INVALID_TOKEN_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.INVALID_TOKEN_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.ERROR_TOKEN) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.ERROR_TOKEN_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.ERROR_TOKEN_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.INVALID_PROCESS) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.INVALID_PROCESS_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.INVALID_PROCESS_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.PROCESS_FINISHED) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.PROCESS_FINISHED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.PROCESS_FINISHED_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.PROCESS_MISMATCH) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.PROCESS_MISMATCH_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.PROCESS_MISMATCH_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.INVALID_COMPANY) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.INVALID_COMPANY_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.INVALID_COMPANY_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.INVALID_APIKEY) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.INVALID_APIKEY_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.INVALID_APIKEY_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.INVALID_PROFILE) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.INVALID_PROFILE_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.INVALID_PROFILE_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.PROFILE_EXPIRED) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.PROFILE_EXPIRED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.PROFILE_EXPIRED_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.PROCESS_ACTIVE_IN_OTHER_TAB) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.PROCESS_ACTIVE_IN_OTHER_TAB_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.PROCESS_ACTIVE_IN_OTHER_TAB_DESCRIPTION' | translate"
                icon="icon-alert"
            >
                @if (errorConfig.action) {
                    <tec-button
                        size="lg"
                        [label]="'GENERAL.BUTTON.CONTINUE_IN_THIS_TAB' | translate"
                        (clickEvent)="errorConfig.action()"
                    />
                }
            </tec-tile>
        }
        @case (ERROR_CODE.MATCH_DATA_EMPTY) {
            <tec-tile
                type="status"
                [title]="'GENERAL.ERROR.GREEN_CARD_NIF_REQUIRED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.GREEN_CARD_NIF_REQUIRED_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @case (ERROR_CODE.PERMISSION_NOT_GRANTED) {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.PERMISSION_NOT_GRANTED_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.PERMISSION_NOT_GRANTED_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
        @default {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'GENERAL.ERROR.GENERIC_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.GENERIC_DESCRIPTION' | translate"
                icon="icon-alert"
            ></tec-tile>
        }
    }
    <!-- <tec-tile
        *ngIf="errorConfig.code.toString().startsWith('10')"
        [title]="'GENERAL.PROCESS.EXPIRED_TITLE' | translate"
        [subtitle]="'GENERAL.PROCESS.EXPIRED_DESCRIPTION' | translate"
        icon="icon-alert"
        [labelAction]="errorConfig.retry ? 'Reintentar' : ''"
        (clickEvent)="errorConfig.retry ? errorConfig.action() : null"
    ></tec-tile> -->
}
